import { Component, Input, OnInit } from '@angular/core'
import { MediaInterface } from '../../../interfaces'

@Component({
  selector: 'dmmp-testimony',
  templateUrl: './testimony.component.html',
})
export class TestimonyComponent implements OnInit {
  @Input() data
  @Input() detailLayout
  testimonials: object
  medias : MediaInterface[] = [
    {style: 'large', media: '(min-width:1301px)'},
    {style: 'max_1300x1300', media: '(min-width:651px) AND (max-width:1300px)'},
    {style: 'max_650x650', media: '(max-width:650px) AND (min-width:326px)'},
    {style: 'max_325x325', media: '(max-width:325px)'},
  ]

  ngOnInit(): void {
    this.data.content && this.data.content.length > 0
      ? (this.testimonials = this.data.content)
      : (this.testimonials = this.detailLayout.testimonials)
  }
}
